'use client';

import React from 'react';
import PropTypes from 'prop-types';
import { ConfigProvider } from 'antd';

const AntdConfigProvider = ({ children }) => (
  <ConfigProvider popupMatchSelectWidth={false}>{children}</ConfigProvider>
);

AntdConfigProvider.propTypes = {
  children: PropTypes.node,
};

export default AntdConfigProvider;
